/********************************************************************************
 * Copyright (c) 2023 Business Informatics Group (TU Wien) and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0 WITH Classpath-exception-2.0
 ********************************************************************************/

.grid-container {
    display: grid;
    position: absolute;
    top: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
    right: 0.5rem;
    grid-template-columns: auto auto auto;
}

.grid-container.grid-visible {
    opacity: 0.7;
    visibility: visible;
}

.grid-container.grid-hidden {
    opacity: 0;
    visibility: hidden;
}

.grid-container:focus {
    opacity: 1;
}

.grid-item {
    border: 1px solid rgba(0, 0, 0, 0.6);
    padding: 1rem;
    /* Fix overlapping borders */
    margin: 0 -1px -1px 0;
}

.grid-item-number {
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0.5rem;

    background: #fff;
    border: 2px solid #666;
    color: black;
    text-align: center;

    font:
        bold 1.3rem Arial,
        sans-serif;
}
